import { useCustomParams } from '@hooks/useCustomParams';
import { DashboardHeader, DivisionChartComponent, Summary } from './components';
import { useDashboardSummary } from '@hooks/useDashboardSummary';

const Dashboard = () => {
  const { searchParams } = useCustomParams();
  const { summaryList, isLoading } = useDashboardSummary();

  return (
    <div className="pt-10">
      <DashboardHeader isLoading={isLoading} />
      <Summary summaryList={summaryList} isLoading={isLoading} />
      <DivisionChartComponent searchParams={searchParams} />
    </div>
  );
};

export default Dashboard;
